import { z } from 'zod';

/** Optionale Ganzzahl, die vom Backend als number|null kommt und im Formular
 *  auch als '' (leer) auftreten kann -> null. */
const optionalInt = z
  .union([z.number(), z.string(), z.null()])
  .transform(value => (value === null || value === '' ? null : Number(value)))
  .nullable()
  .default(null);

const asBool = (fallback: boolean) =>
  z
    .union([z.boolean(), z.number(), z.null()])
    .transform(value => (value === null ? fallback : Boolean(value)))
    .default(fallback);

/**
 * Terminart (MeetingType), interne Sicht. Feldnamen entsprechen der API
 * (generisches CRUD). Relations-FKs kommen als Alias-Keys
 * (idLocation/idRoom/idUserCalendarConnection/idUser).
 */
export const meetingTypeSchema = z.object({
  idMeetingType: z.number().default(-1),
  Name: z.string().default(''),
  DurationInMin: z.number().default(30),
  BufferBeforeMin: z.number().default(0),
  BufferAfterMin: z.number().default(0),
  SlotStepInMin: optionalInt,
  MinLeadTimeMinutes: optionalInt,
  BookingHorizonDays: optionalInt,
  idLocation: z.number().nullable().default(null),
  idRoom: z.number().nullable().default(null),
  idUserCalendarConnection: z.number().nullable().default(null),
  idUser: z.number().nullable().default(null),
  IsBookablePublic: asBool(false),
  IsActive: asBool(true),
  AllowParallel: asBool(false),
});

export type IMeetingType = z.infer<typeof meetingTypeSchema>;
